import Data from 'data';
import { deepCopy } from 'utils';

export const skills = {
  bonespikes: {
    params: [{rune: "b", min: 8, max: 80, name: "Distance"}],
    info: {
      "*": {"Damage": {elem: "phy", coeff: 1.2}, "DPS": {sum: true, "Damage": {speed: "passives.swiftharvesting?1.15:1", fpa: 60, round: "up"}}},
      a: {"Damage": {elem: "phy", coeff: 1.2}},
      c: {"Damage": {elem: "psn", coeff: 1.8}, "DPS": {sum: true, "Damage": {speed: "passives.swiftharvesting?1.15:1", fpa: 58.0645, round: "up"}}},
      d: {"Damage": {elem: "col", coeff: 1.2}},
      b: {"Damage": {elem: "phy", coeff: "0.8+0.8*($1-8)/72"}, "DPS": {sum: true, "Damage": {speed: "passives.swiftharvesting?1.15:1", fpa: 58.0645, round: "up"}}},
      e: {"Damage": {elem: "phy", coeff: 1.2}, "Bleed Damage": {elem: "phy", coeff: 0.5}},
    },
  },
  grimscythe: {
    params: [{rune: "c", name: "Stacks", min: 0, max: 15, val: 0},
             {min: 0, max: 50, val: 10, name: "Enemies Hit", buffs: false, show(rune, stats) {
               // This only affects simulacrums
               return !!((stats.leg_legersdisdain || stats.leg_legersdisdain_p6) && stats.skills.simulacrum && Data.skills.necromancer.simulacrum.active && stats.leg_hauntedvisions_p69);
             }}],
    info(rune, stats) {
      const res = {"Damage": {elem: "phy", coeff: 1.5}, "DPS": {sum: true, "Damage": {speed: "passives.swiftharvesting?1.15:1", fpa: 58.0645, round: "up"}}};
      if (rune === "e") res["Damage"].elem = "psn";
      if (rune === "c") res["Damage"].elem = "col";
      if (stats.skills.simulacrum && Data.skills.necromancer.simulacrum.active && stats.leg_hauntedvisions_p69) {
        res["Simulacrum Damage"] = deepCopy({}, res["Damage"]);
        if (stats.leg_legersdisdain || stats.leg_legersdisdain_p6) {
          res["Simulacrum Damage"].percent = {
            [Data.itemById.P6_Unique_Phylactery_03.name]: (stats.leg_legersdisdain || stats.leg_legersdisdain_p6) * this.params[1].val * 12 * (1 + 0.01 * (stats.resourcegen || 0))
          };
        }
        res["DPS"]["Simulacrum Damage"] = deepCopy({}, res["DPS"]["Damage"]);
        res["DPS"]["Simulacrum Damage"].count = ((stats.skills.simulacrum === "d" || stats.set_masquerade_2pc) ? 2 : 1);
      }
      return res;
    },
    active: true,
    buffs(rune, stats) {
      if (rune === "c") {
        return {ias: this.params[0].val};
      }
    },
  },
  siphonblood: {
    params: [{rune: "d", min: 0, max: 10, val: 0, name: "Stacks", buffs: false}],
    info(rune, stats) {
      const res = {"DPS": {elem: "phy", aps: true, coeff: 3.0, total: true, passives: {"swiftharvesting": 15}}};
      res["DPS"].elem = Data.skilltips.necromancer.siphonblood.elements[rune] || 'phy';
      if (rune === 'd' || stats.set_trangoul_2pc) {
        res["DPS"].percent = {"Stacks": (stats.leg_funerarypick_p74 ? 20 : 10) * this.params[0].val};
      }
      return res;
    },
  },
  bonespear: {
    active: true,
    params: [{rune: "c", min: 0, max: 10, inf: true, val: 0, name: "Enemies Hit", buffs: false},
             {rune: "a", min: 0, max: 10, val: 0, name: "Enemies Hit"}],
    info(rune, stats) {
      const res = {"Cost": {cost: 20}, "Damage": {elem: "phy", coeff: 5.0}, "DPS": {sum: true, "Damage": {speed: 1, fpa: 58.0645, round: "up"}}};
      if (stats.leg_maltoriuspetrifiedspike || stats.leg_maltoriuspetrifiedspike_p6) res["Cost"].cost = 40;
      if (rune === "c") { res["Damage"].elem = "psn"; res["Damage"].percent = {"Bonus": 15 * this.params[0].val}; }
      if (rune === "e") res["Damage"].coeff = 3.0;
      if (rune === "a") res["Damage"].elem = "col";
      if (rune === "d") res["Damage"].coeff = 6.5;
      if (stats.set_masquerade_6pc) {
        res["Damage"].percent = (res["Damage"].percent || {});
        res["Damage"].percent[Data.itemSets.masquerade.name] = 5500;
      }
      if (stats.skills.simulacrum && Data.skills.necromancer.simulacrum.active) {
        res["Simulacrum Damage"] = deepCopy({}, res["Damage"]);
        res["Simulacrum Damage"].percent = (res["Simulacrum Damage"].percent || {});
        if (stats.leg_gelmindorsmarrowguards) {
          res["Simulacrum Damage"].percent[Data.itemById.P610_Unique_Bracer_22.name] = stats.leg_gelmindorsmarrowguards;
        }
        if (stats.set_masquerade_6pc) {
          res["Simulacrum Damage"].percent[Data.itemSets.masquerade.name] = 5500 * 3;
        }
        res["DPS"]["Simulacrum Damage"] = Object.assign({}, res["DPS"]["Damage"]);
        res["DPS"]["Simulacrum Damage"].count = ((stats.skills.simulacrum === "d" || stats.set_masquerade_2pc) ? 2 : 1);
        res["DPS"]["Simulacrum Damage"].nobp = true;
      }
      return res;
    },
    buffs(rune, stats) {
      if (rune === "a") {
        return {weaponaps: 0.03 * this.params[1].val};
      }
    },
  },
  skeletalmage: {
    params: [{min: 0, max: 10, val: 1, name: "Count", buffs: false},
             {rune: "e", min: 0, max: 10, name: "Stacks"},
             {rune: "b", min: "40*(1-0.01*rcr_essence)-rcrint", max: "maxessence", name: "Essence", buffs: false}],
    info(rune, stats) {
      const res = {
        "Cost": {cost: 40},
        "Duration": {duration: ((rune === "c" ? 8 : 6) + (stats.leg_circleofnailujsevol || 0)) * (stats.passives.extendedservitude ? 1.25 : 1)},
        "Damage": {elem: "phy", pet: true, aps: true, coeff: 2.0},
        "DPS": {sum: true, "Damage": {pet: 30, nobp: true}},
        "Total DPS": {sum: true, "DPS": {count: this.params[0].val}},
      };
      if (rune === "d") {
        res["Damage"].elem = "psn";
        res["Aura DPS"] = {elem: "psn", total: true, aps: true, coeff: 1.0};
        res["DPS"]["Aura DPS"] = {};
      }
      if (rune === "e") {
        res["Damage"].elem = "col";
        res["Damage"].coeff = 4.0;
        res["DPS"]["Damage"].pet = 60;
      }
      if (rune === "b" || stats.leg_razethsvolition_p69) {
        const consumed = this.params[2].val - 40 * (1 - 0.01 * (stats.rcr_essence || 0)) + (stats.rcrint || 0);
        if (consumed > 0) {
          res["Damage"].percent = {"Essence Consumed": 3 * consumed};
        }
      }
      return res;
    },
    active: true,
    buffs(rune, stats) {
      if (rune === "e") {
        return {weaponaps: 0.03 * this.params[1].val};
      }
    },
  },
  deathnova: {
    params: [{min: 0, max: 10, val: 10, name: "Stacks", show(rune, stats) {
               return !!stats.leg_ironrose_p74;
             }}],
    info(rune, stats) {
      const res = {"Damage": {elem: "psn", coeff: 3.5}, "DPS": {sum: true, "Damage": {speed: 1.2, fpa: 58.0645, round: "up"}}, "Cost": {cost: 20}};
      if (rune === "a") res["Damage"] = {elem: "phy", coeff: 2.25};
      if (rune === "b") res["Damage"] = {elem: "phy", coeff: 4.75};
      if (rune === "c") res["Damage"] = {elem: "phy", coeff: 4.5};
      if (stats.skills.simulacrum && Data.skills.necromancer.simulacrum.active) {
        res["DPS"]["Damage"].count = ((stats.skills.simulacrum === "d" || stats.set_masquerade_2pc) ? 3 : 2);
      }
      return res;
    },
    buffs(rune, stats) {
      if (stats.leg_ironrose_p74 && this.params[0].val) {
        return {dmgmul: {skills: ["deathnova"], percent: stats.leg_ironrose_p74 * this.params[0].val}};
      }
    },
  },
  corpseexplosion: {
    info: {
      "*": {"Damage": {elem: "phy", coeff: 10.5}},
      d: {"Damage": {elem: "phy", coeff: 10.5}},
      c: {"Damage": {elem: "psn", coeff: 15.75}},
      a: {"Damage": {elem: "psn", coeff: 10.5}},
      e: {"Damage": {elem: "col", coeff: 10.5}},
      b: {"Damage": {elem: "phy", coeff: 10.5}},
    },
  },
  corpselance: {
    params: [{rune: "b", min: 0, max: 20, val: 0, name: "Stacks"},
             {min: 0, max: 20, name: "Corpses Consumed", buffs: false, show(rune, stats) {
               return !!stats.leg_corpsewhisperpauldrons;
             }}],
    info(rune, stats) {
      const res = {"Damage": {elem: "phy", coeff: 17.5}};
      if (rune === "e") res["Damage"].elem = "psn";
      if (rune === "b") res["Damage"].elem = "col";
      if (rune === "a") res["Damage"].elem = "psn";
      if (rune === "c") res["Additional Damage"] = {elem: "phy", coeff: 5.25};
      if (stats.leg_corpsewhisperpauldrons) {
        const pct = {[Data.itemById.P6_Necro_Unique_Shoulders_21.name]: stats.leg_corpsewhisperpauldrons * this.params[1].val};
        res["Damage"].percent = pct;
        if (res["Additional Damage"]) res["Additional Damage"].percent = pct;
      }
      res["DPS"] = {sum: true, "Damage": {speed: 1, fpa: 12}};
      if (res["Additional Damage"]) res["DPS"]["Additional Damage"] = {speed: 1, fpa: 12, nobp: true};
      return res;
    },
    active: true,
    buffs(rune, stats) {
      if (rune === "b") {
        return {chctaken: 5 * this.params[0].val};
      }
    },
  },
  devour: {
    active: true,
    params: [{rune: "ec", min: 0, max: 25, val: 0, name: "Stacks"}],
    buffs(rune, stats) {
      if (rune === "e") return {life: 2 * this.params[0].val};
      if (rune === "c") return {rcr: 2 * this.params[0].val};
    },
  },
  revive: {
    active: true,
    params: [{rune: "c", min: 0, max: 10, val: 0, name: "Stacks"}],
    buffs(rune, stats) {
      if (rune === "c") {
        return {dmgred: this.params[0].val};
      }
    },
  },
  commandskeletons: {
    params: [{min: 1, max: 7, name: "Skeletons", buffs: false},
             {min: 0, max: 60, name: "Active Time", buffs: false, show(rune, stats) {
               return !!stats.leg_boneringer;
             }}],
    info(rune, stats) {
      const res = {
        "Cost": {cost: 50, rcr: {commanderoftherisendead: (stats.passives.commanderoftherisendead ? 30 : 0)}},
        "Damage": {elem: "phy", pet: true, coeff: 0.5},
        "DPS": {sum: true, "Damage": {pet: 50, speed: 1, count: this.params[0].val}},
      };
      let allRunes = false;
      if (stats.leg_bloodsongmail && stats.skills.landofthedead && Data.skills.necromancer.landofthedead.active) {
        allRunes = true;
      }
      if (allRunes || rune === "a") res["Cost"].cost = 25;
      if (allRunes || rune === "e") if (this.active) res["DPS"]["Damage"].pet = 40;
      if (rune === "c") res["Damage"].elem = "col";
      if (rune === "d") res["Damage"].elem = "psn";
      if (allRunes || rune === "d") {
        res["Explosion Damage"] = {elem: res["Damage"].elem, pet: true, coeff: 2.15};
        res["Total Explosion Damage"] = {sum: true, "Explosion Damage": {count: this.params[0].val}};
      }
      if (stats.passives.aberrantanimator && stats.thorns) {
        res["Thorns"] = {coeff: 2, thorns: "normal", pet: true, srcelem: "phy", elem:  res["Damage"].elem};
      }
      if (stats.leg_boneringer) {
        const pct = {[Data.itemById.P6_Unique_Phylactery_02.name]: stats.leg_boneringer * this.params[1].val};
        res["Damage"].percent = pct;
        if (res["Explosion Damage"]) res["Explosion Damage"].percent = pct;
        if (res["Thorns"]) res["Thorns"].percent = pct;
      }
      return res;
    },
    active: false,
    buffs(rune, stats) {
      const res = {dmgmul: {list: [{skills: ["commandskeletons"], percent: 50}]}};
      if (stats.set_jesseth_2pc) {
        res.dmgmul.list.push({source: "set_jesseth_2pc", value: {percent: 400}});
      }
      return res;
    },
  },
  commandgolem: {
    info(rune, stats) {
      const res = {
        "Damage": {elem: "phy", pet: true, coeff: 4.5, aps: true},
        "DPS": {sum: true, "Damage": {pet: 90}},
        "Cooldown": {cooldown: 45, cdr: stats.passives.commanderoftherisendead ? 30 : 0},
      };
      if (stats.leg_golemskinbreeches_p6) res["Cooldown"].cooldown -= stats.leg_golemskinbreeches_p6;
      switch (rune) {
      case "e": res["Damage"].elem = "col"; break;
      case "a": res["Activation Damage"] = {elem: "phy", pet: true, coeff: 20.0, total: true}; break;
      case "c": res["Damage"].elem = "psn"; break;
      // no default
      }
      return res;
    },
    active: false,
    params: [{rune: "c", min: 0, max: 10, val: 0, name: "Corpses Consumed"}],
    buffs(rune, stats) {
      const res = {};
      if (rune === "e") res.chctaken = 10;
      if (rune === "c") res.dmgmul = {skills: ["commandgolem"], percent: 30 * this.params[0].val};
      if (stats.leg_golemskinbreeches || stats.leg_golemskinbreeches_p6) res.dmgred = 30;
      return res;
    },
  },
  armyofthedead: {
    info(rune, stats) {
      const res = {"Damage": {elem: "phy", coeff: 120.00, total: true}, "Cooldown": {cooldown: 120}};
      if (stats.leg_fatesvow || stats.leg_fatesvow_p6) {
        res["Damage"].addcoeff = [500];
      } else if (rune === "c") {
        res["Damage"].coeff = 500.0;
      }
      if (rune === "a") res["Damage"].coeff = 140.0;
      if (rune === "e") res["Damage"].coeff = 155.0;
      if (rune === "a") res["Damage"].elem = "psn";
      if (rune === "b") res["Damage"].elem = "col";
      return res;
    },
  },
  landofthedead: {
    info: {
      "*": {"Cooldown": {cooldown: 120}},
      c: {"DPS": {elem: "psn", coeff: 1, total: true}, "Total Damage": {elem: "psn", coeff: 100.00, total: true}},
    },
    active: false,
    buffs(rune, stats) {
      const res = {};
      if (stats.leg_bloodsongmail) {
        res.dmgmul = {skills: ["commandskeletons"], percent: stats.leg_bloodsongmail};
      }
      if (rune === "a") res.rcr_essence = 100;
      return res;
    },
  },
  decrepify: {
    active: false,
    info: {
      "*": {"Cost": {cost: 10, rcr: {eternaltorment: "passives.eternaltorment?50:0"}}},
    },
    params: [{rune: "b", min: 0, max: 10, val: 0, name: "Stacks"},
             {rune: "c", min: 0, max: 20, val: 0, name: "Stacks"},],
    buffs(rune, stats) {
      const res = {};
      if (rune === "b") res.extrams = this.params[0].val * 3;
      if (rune === "c") res.cdr = this.params[1].val;
      if (stats.leg_daynteesbinding) res.dmgred = stats.leg_daynteesbinding;
      return res;
    },
  },
  leech: {
    info: {
      "*": {"Cost": {cost: 10, rcr: {eternaltorment: "passives.eternaltorment?50:0"}}},
    },
    active: false,
    params: [{rune: "ad", min: 0, max: 20, val: 0, name: "Enemies Hit"}],
    buffs(rune, stats) {
      if (rune === "a") return {regen: this.params[0].val * 751};
      if (rune === "d") return {regen_percent: this.params[0].val};
    },
  },
  frailty: {
    info: {
      "*": {"Cost": {cost: 10, rcr: {eternaltorment: "passives.eternaltorment?50:0"}}},
      c: {"Damage": {elem: "phy", coeff: 1.00}},
      e: {"Range": "@15+pickup*0.5", "Cost": null},
    },
    active: false,
    buffs(rune, stats) {
      if (rune === "d") return {dmgmul: {pet: true, percent: 15}};
    },
  },
  bonearmor: {
    info(rune, stats) {
      const res = {"Damage": {elem: "phy", coeff: 1.25}, "Cooldown": {cooldown: 10}};
      if (rune === "a") res["Damage"].coeff = 1.45;
      if (rune === "c") res["Damage"].elem = "psn";
      if (rune === "b") res["Cooldown"].cooldown = 45;
      if (rune === "e") res["Damage"].elem = "col";
      if (stats.set_inarius_6pc) {
        res["DPS"] = {elem: res["Damage"].elem, coeff: 10, total: true};
      }
      return res;
    },
    active: false,
    params: [{min: 1, max: "10+(leg_wisdomofkalan?5:0)", val: 0, name: "Stacks"}],
    buffs(rune, stats) {
      if (!this.params[0].val) return;
      const res = {dmgred: (stats.set_inarius_4pc ? 6 : 3) * this.params[0].val};
      if (rune === "e") res.extrams = this.params[0].val;
      if (rune === "d") res.regen_bonus = 10 * this.params[0].val;
      res.dmgmul = {list: []};
      if (stats.leg_scytheofthecycle) {
        res.dmgmul.list.push({source: "P6_Unique_Scythe1H_03", value: {skills: ["bonespear", "skeletalmage", "deathnova"], percent: stats.leg_scytheofthecycle}});
      }
      if (stats.leg_scytheofthecycle_p6) {
        res.dmgmul.list.push({source: "P61_Unique_Scythe1H_03", value: {skills: ["bonespear", "skeletalmage", "deathnova"], percent: stats.leg_scytheofthecycle_p6}});
      }
      if (stats.set_inarius_6pc) {
        res.dmgmul.list.push({source: "set_inarius_6pc", value: 19000});
      }
      return res;
    },
  },
  bonespirit: {
    params: [{rune: "e", min: 0, max: 10, inf: true, val: 0, name: "Enemies Hit", buffs: false},
             {min: 0, max: 30, name: "Active Time", buffs: false, show(rune, stats) {
               return !!(stats.leg_defilercuisses || stats.leg_defilercuisses_p6);
             }}, {min: 0, max: 5, name: "Active Time", buffs: false, show(rune, stats) {
               return !!stats.leg_defilercuisses_p7;
             }}],
    info(rune, stats) {
      const res = {"Damage": {elem: "phy", coeff: 40.00}, "Cooldown": {cooldown: 15}};
      if (rune === "e") res["Damage"] = {elem: "col", coeff: 40.00, percent: {"Bonus": 15 * this.params[0].val}};
      if (rune === "b") res["Damage"].elem = "psn";
      if (rune === "d") res["Damage"] = {elem: "col", coeff: 12.50};
      if (stats.leg_defilercuisses || stats.leg_defilercuisses_p6) {
        res["Damage"].percent = {[Data.itemById.P6_Necro_Unique_Pants_22.name]: (stats.leg_defilercuisses || stats.leg_defilercuisses_p6) * this.params[1].val, ...res["Damage"].percent};
      }
      if (stats.leg_defilercuisses_p7) {
        res["Damage"].percent = {[Data.itemById.P7_Necro_Unique_Pants_22.name]: stats.leg_defilercuisses_p7 * this.params[2].val, ...res["Damage"].percent};
      }
      return res;
    },
  },
  bloodrush: {
    info: {
      "*": {"Cooldown": {cooldown: 5}},
    },
    active: false,
    buffs(rune, stats) {
      if (rune === "d" || stats.set_trangoul_2pc) return {armor_percent: 100};
    },
  },
  simulacrum: {
    info: {
      "*": {"Cooldown": {cooldown: 120}},
    },
    active: false,
    activeshow(rune, stats) {
      return true;
    },
    buffs(rune, stats) {
      const res = {};
      if (rune === "a" || stats.set_masquerade_2pc) res.maxessence_percent = 100;
      if (stats.set_masquerade_4pc) res.dmgred = 100 * (1 - 0.5 / 3); // 83%
      return res;
    },
  },
};

export const passives = {
  lifefromdeath: {
  },
  fueledbydeath: {
    active: true,
    params: [{min: 0, max: 10, name: "Stacks"}],
    buffs(stats) {
      return {extrams: this.params[0].val * 3};
    },
  },
  standalone: {
    active: true,
    params: [{min: 0, max: 10, name: "Minions"}],
    buffs(stats) {
      return {armor_percent: 100 - 10 * this.params[0].val};
    },
  },
  boneprison: {
  },
  swiftharvesting: {
  },
  commanderoftherisendead: {
  },
  extendedservitude: {
  },
  rigormortis: {
  },
  overwhelmingessence: {
    buffs: {maxessence: 40},
  },
  darkreaping: {
  },
  spreadingmalediction: {
    active: true,
    params: [{min: 0, max: 20, inf: true, name: "Stacks"}],
    buffs(stats) {
      return {damage: this.params[0].val};
    },
  },
  eternaltorment: {
  },
  finalservice: {
  },
  grislytribute: {
  },
  drawlife: {
    active: true,
    params: [{min: 0, max: 20, inf: true, name: "Nearby Enemies"}],
    buffs(stats) {
      return {regen_bonus: 10 * this.params[0].val};
    },
  },
  serration: {
    active: true,
    params: [{min: 0, max: 30, step: 1.5, name: "Distance"}],
    buffs(stats) {
      return {dmgmul: {skills: ["bonespikes", "bonespear", "bonespirit"], percent: this.params[0].val / 1.5}};
    },
  },
  aberrantanimator: {
  },
  bloodforblood: {
  },
  bloodispower: {
  },
  rathmasshield: {
  },
};

export const partybuffs = {
  corpselance: {
    runelist: "b",
    params: [{min: 0, max: 20, val: 0, name: "Stacks"}],
    buffs(stats) {
      return {chctaken: this.params[0].val * 5};
    },
  },
  commandgolem: {
    runelist: "e",
  },
};
